// src/index.js

// Gestione globale degli errori per prevenire "Script error" su Safari
// Intercetta errori cross-origin e altri errori non gestiti
(function() {
  'use strict';
  
  // Gestore errori globali
  window.addEventListener('error', function(event) {
    // Ignora errori cross-origin (Script error) che non possono essere letti
    // Questi errori sono comuni su Safari quando script esterni falliscono
    if (event.message === 'Script error.' || event.message === '' || 
        (event.filename && event.filename.indexOf('http') === 0 && 
         event.filename.indexOf(window.location.origin) === -1)) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    
    // Permetti ad altri errori di essere gestiti normalmente
    return true;
  }, true);
  
  // Gestore per Promise non gestite
  window.addEventListener('unhandledrejection', function(event) {
    // Ignora errori cross-origin
    if (event.reason && typeof event.reason === 'string' && 
        event.reason.includes('Script error')) {
      event.preventDefault();
      return false;
    }
    
    // Permetti ad altre rejection di essere gestite normalmente
    return true;
  });
})();

import jquery from "jquery";
window.jQuery = window.$ = jquery;

// Bootstrap Framework
import "./scss/index.scss";
import "@popperjs/core";
import "bootstrap";

// Espone Bootstrap globalmente per compatibilità
import 'bootstrap';
window.bootstrap = require('bootstrap');


// Costanti
const SCROLL_DURATION = 300;

// Gestione animazione offcanvas
document.addEventListener('DOMContentLoaded', function() {
  const offcanvas = document.querySelector('.offcanvas');
  if (offcanvas) {
    offcanvas.addEventListener('hide.bs.offcanvas', function () {
      this.classList.add('hiding');
      setTimeout(() => {
        this.classList.remove('hiding');
      }, 600);
    });
  }
});

// Aggiungi l'animazione squash al click del toggler
document.addEventListener('DOMContentLoaded', function() {
  const navbarToggler = document.querySelector('.navbar-toggler');
  if (navbarToggler) {
    navbarToggler.addEventListener('click', function() {
      // Aggiungi la classe per l'animazione
      this.classList.add('squash');
      
      // Rimuovi la classe dopo l'animazione
      setTimeout(() => {
        this.classList.remove('squash');
      }, 600);
    });
  }
});
//#endregion

//#region stickybar
document.addEventListener("DOMContentLoaded", function () {
  const stickybar = document.querySelector(".stickybar");
  let lastScrollTop = 0;

  window.addEventListener("scroll", function() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > 0) {
      stickybar.classList.add("stickybar--sticked");
    } else {
      stickybar.classList.remove("stickybar--sticked");
    }
    
    lastScrollTop = scrollTop;
  });
});
//#endregion


// Funzione di scroll fluido personalizzato
function smoothScrollTo(target, duration = SCROLL_DURATION) {
  const startY = window.scrollY;
  const targetElement = document.querySelector(target);
  if (!targetElement) return;
  const targetY = targetElement.getBoundingClientRect().top + window.scrollY;
  const diff = targetY - startY;
  let startTime = null;

  function step(currentTime) {
    if (!startTime) startTime = currentTime;
    const time = currentTime - startTime;
    const percent = Math.min(time / duration, 1);
    // Ease in-out
    const ease = percent < 0.5
      ? 2 * percent * percent
      : -1 + (4 - 2 * percent) * percent;
    window.scrollTo(0, startY + diff * ease);
    if (time < duration) {
      requestAnimationFrame(step);
    }
  }
  requestAnimationFrame(step);
}

//#region Slide Buttons Animation
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.btn-slide-container .btn').forEach(button => {
    button.addEventListener('click', function(e) {
      // Ottieni l'URL di destinazione
      const targetUrl = this.getAttribute('href');
      
      // Verifica se è un URL esterno (http:// o https://)
      const isExternalUrl = targetUrl && (targetUrl.startsWith('http://') || targetUrl.startsWith('https://'));
      
      // Se è un URL esterno, permettere il comportamento predefinito del link
      if (isExternalUrl) {
        // Aggiungi la classe per l'animazione ma non prevenire il comportamento predefinito
        this.classList.add('squash');
        setTimeout(() => {
          this.classList.remove('squash');
        }, 250);
        // Il link seguirà il suo comportamento normale (aprirà l'URL esterno)
        return;
      }
      
      // Se è un selettore CSS (anchor interno), previeni l'azione e fai lo scroll
      e.preventDefault();
      
      // Aggiungi la classe per l'animazione
      this.classList.add('squash');
      
      // Rimuovi la classe dopo l'animazione e poi esegui lo scroll
      setTimeout(() => {
        this.classList.remove('squash');
        // Esegui lo scroll dopo 250ms con animazione personalizzata
        setTimeout(() => {
          smoothScrollTo(targetUrl);
        }, 250);
      }, 250);
    });
  });
});
//#endregion

//#region Carousel Scroll
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('#carousel01');
  if (carousel && window.bootstrap) {
    const carouselInstance = new bootstrap.Carousel(carousel, {
      interval: 10000,
      wrap: true,
      touch: true,
      pause: false,
      ride: 'carousel'
    });
  }

  // Gestione degli indicatori del carousel
  document.querySelectorAll('#carousel01 .carousel-indicators button').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Aggiungi la classe per l'animazione
      this.classList.add('squash');
      
      // Rimuovi la classe dopo l'animazione
      setTimeout(() => {
        this.classList.remove('squash');
      }, 600);
    });
  });
});
//#endregion

// Logo Loading Strategy
document.addEventListener('DOMContentLoaded', function() {
  const logos = document.querySelectorAll('.logo-loading');
  
  function handleLogoLoad(logo) {
      // Piccolo ritardo per assicurare che l'animazione sia visibile
      setTimeout(() => {
          logo.classList.add('loaded');
      }, 100);
  }
  
  logos.forEach(logo => {
      if (logo.complete) {
          handleLogoLoad(logo);
      } else {
          logo.addEventListener('load', () => handleLogoLoad(logo));
      }
  });
});

// Loading Strategy
document.addEventListener('DOMContentLoaded', function() {
    const loadingElements = document.querySelectorAll('.loading');
    
    function handleElementLoad(element) {
        // Piccolo ritardo per assicurare che l'animazione sia visibile
        setTimeout(() => {
            element.classList.add('loaded');
        }, 100);
    }
    
    loadingElements.forEach(element => {
        if (element.tagName === 'IMG') {
            if (element.complete) {
                handleElementLoad(element);
            } else {
                element.addEventListener('load', () => handleElementLoad(element));
            }
        } else {
            // Per elementi non-immagine, aggiungiamo direttamente la classe loaded
            handleElementLoad(element);
        }
    });
});

// Gestione modali Bootstrap
document.addEventListener('DOMContentLoaded', function() {
  // Inizializza tutte le modali Bootstrap
  const modals = document.querySelectorAll('.modal');
  modals.forEach(modal => {
    // Crea istanza Bootstrap per ogni modale
    const modalInstance = new bootstrap.Modal(modal);
    
    // Gestione apertura modale
    const triggerElements = document.querySelectorAll(`[data-bs-target="#${modal.id}"]`);
    triggerElements.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        modalInstance.show();
      });
    });
    
    // Gestione chiusura modale
    const closeButtons = modal.querySelectorAll('[data-bs-dismiss="modal"]');
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        modalInstance.hide();
      });
    });
    
    // Gestione chiusura con ESC
    modal.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('show')) {
        modalInstance.hide();
      }
    });
    
    // Gestione chiusura cliccando fuori dalla modale
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modalInstance.hide();
      }
    });
  });
});

